require('./featureslider');
require('./imageCarouselWithThumbnail');